import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";

export default function MemoryTabOficial() {
  const { data, isLoading } = useQuery({
    queryKey: ["ltm-canonical-list"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("ltm_canonical")
        .select("id, topic, statement, evidence_excerpt, source_type, confidence, effective_until, approved_at")
        .is("effective_until", null)
        .order("approved_at", { ascending: false, nullsFirst: false })
        .limit(100);
      if (error) throw error;
      return data ?? [];
    },
  });

  if (isLoading) return <Skeleton className="h-64" />;

  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        Verdade oficial do negócio. Vale como regra. Só admin promove ou aposenta.
      </p>
      {!data?.length ? (
        <Card><CardContent className="py-10 text-center text-muted-foreground text-sm">
          Sem regras oficiais ainda. Promova um padrão para cá.
        </CardContent></Card>
      ) : data.map(r => (
        <Card key={r.id}>
          <CardHeader className="pb-2">
            <div className="flex items-start justify-between gap-3">
              <CardTitle className="text-sm font-semibold">{r.topic}</CardTitle>
              <Badge variant="secondary">{r.source_type}</Badge>
            </div>
          </CardHeader>
          <CardContent className="pt-0 space-y-2">
            <p className="text-sm">{r.statement}</p>
            {r.evidence_excerpt && (
              <p className="text-xs text-muted-foreground border-l-2 pl-2 italic">{r.evidence_excerpt}</p>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
